import React from 'react';
import { motion } from "framer-motion"
import logo from '../resources/logo.svg';

import styles from './Loading.module.scss';

const Loading = () => {
  return (
    <div className={styles.loading}>
      <motion.div
      intial={{ scale: 1.0, opacity: 0.25 }}
      animate={{ scale: 0.9, opacity: 0.75 }}
      transition={{ yoyo: Infinity }}
      >
        <img src={logo} alt="logo" />
      </motion.div>
    </div>
  )
}

export default Loading;
